<i class="fas fa-chevron-down" *ngIf="!page.applyButtonAsSeparator"></i>
<fc-apply [settings]="applySettings" *ngIf="page.applyButtonAsSeparator"></fc-apply>